module.exports = "<div class=\"flex flex-v-center flex-h-center\">\n  <h1>\n    404 error\n  </h1>\n</div>\n"